const ElectricityIcon = () => {
  return (
    <span className="w-[42px] h-[42px] rounded-full block bg-gradient-to-tr from-[#e5098b] to-[#ff594f] mr-3">
      <svg xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#FFF"
          d="M18.55 34.125V23.019h-4.375l8.75-15.144v11.106H27.3z"
        />
      </svg>
    </span>
  );
};

export default ElectricityIcon;
